/**
 * Live-filter voor de FAQ-secties op de klantenservice-hub (RESEARCH.md ⑥):
 * doorzoekt alle vraag/antwoord-paren in de DOM, verbergt secties zonder
 * match en opent matchende accordions. Bij nul resultaten verschijnt de
 * fallback met contactknoppen. Zonder JS blijft de zoekbalk verborgen
 * ([hidden] op de wrapper wordt hier weggehaald).
 *
 * Misgrepen worden pas na een typepauze van 1,5 s gelogd (GA4 'faq_search_miss'
 * als dataLayer bestaat); dezelfde term wordt nooit dubbel gelogd (timer én
 * blur zouden anders allebei vuren).
 *
 * In de theme editor herbindt het filter zichzelf na een sectie-herrender
 * via shopify:section:load (live rendert een pagina maar één keer).
 */

let missTimer = null;
let laatsteMiss = '';

function pushMiss(term) {
  if (term === laatsteMiss) return;
  laatsteMiss = term;
  window.dataLayer?.push({ event: 'faq_search_miss', zoekterm: term });
}

function verzamelItems() {
  return [...document.querySelectorAll('.faq .faq__item')].map((el) => ({
    el,
    sectie: el.closest('.shopify-section'),
    tekst: el.textContent.toLowerCase(),
  }));
}

let items = [];

function initFaqFilter() {
  const wrap = document.querySelector('[data-faq-zoek-wrap]');
  const veld = document.querySelector('[data-faq-zoek]');
  const teller = document.querySelector('[data-faq-teller]');
  const leeg = document.querySelector('[data-faq-leeg]');

  items = verzamelItems();
  if (!wrap || !veld || !items.length) return;

  function filter() {
    const term = veld.value.trim().toLowerCase();
    clearTimeout(missTimer);

    if (term.length < 2) {
      for (const item of items) {
        item.el.hidden = false;
        item.el.open = false;
        if (item.sectie) item.sectie.hidden = false;
      }
      if (teller) teller.hidden = true;
      if (leeg) leeg.hidden = true;
      return;
    }

    const secties = new Set();
    let treffers = 0;
    for (const item of items) {
      const match = item.tekst.includes(term);
      item.el.hidden = !match;
      item.el.open = match;
      if (match) {
        treffers += 1;
        if (item.sectie) secties.add(item.sectie);
      }
    }
    for (const item of items) {
      if (item.sectie) item.sectie.hidden = !secties.has(item.sectie);
    }

    if (teller) {
      teller.hidden = false;
      teller.textContent =
        treffers === 1 ? teller.dataset.one || '1 antwoord gevonden' : `${treffers} ${teller.dataset.many || 'antwoorden gevonden'}`;
    }
    if (leeg) leeg.hidden = treffers > 0;
    if (treffers === 0) {
      missTimer = setTimeout(() => pushMiss(term), 1500);
    }
  }

  wrap.hidden = false;
  if (!wrap.dataset.bound) {
    wrap.dataset.bound = 'true';
    veld.addEventListener('input', filter);
    veld.addEventListener('blur', () => {
      clearTimeout(missTimer);
      const term = veld.value.trim().toLowerCase();
      if (term.length >= 2 && items.every((i) => !i.tekst.includes(term))) {
        pushMiss(term);
      }
    });
  }
}

initFaqFilter();

if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', initFaqFilter);
}
